var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallMicOffi = function SvgCallMicOffi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11.365 15.464q.312.042.635.042a4.724 4.724 0 0 0 4.722-4.722.8.8 0 0 1 1.6 0 6.33 6.33 0 0 1-5.522 6.272v3.385h1.667a.8.8 0 0 1 0 1.6H9.533a.8.8 0 0 1 0-1.6H11.2v-3.385a6.3 6.3 0 0 1-1.166-.262l1.33-1.33zM16.22 10.6v.102A4.22 4.22 0 0 1 12 14.931l-.102-.001 4.32-4.32zm-9.422 3.765a6.3 6.3 0 0 1-1.119-3.591.8.8 0 0 1 1.6 0c0 .9.247 1.723.676 2.434zm1.55-1.55a4.2 4.2 0 0 1-.567-2.112V6.178a4.22 4.22 0 0 1 8.298-1.085l-1.46 1.46v-.375A2.62 2.62 0 0 0 12 3.559a2.62 2.62 0 0 0-2.619 2.619v4.534a2.6 2.6 0 0 0 .164.914l-1.197 1.198z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e91e63",
    d: "M6.199 18.932 18.93 6.201A.8.8 0 0 0 17.8 5.069L5.067 17.801A.8.8 0 0 0 6.2 18.932"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallMicOffi);
export default ForwardRef;